// extracted by mini-css-extract-plugin
export var compactFilters = "_di-4";
export var detailImage = "_di-1";
export var dropdownContainer = "_di-2";
export var imageContainer = "_di-0";
export var selectedCard = "_di-3";